import { useState, useContext } from 'react'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { UserIcon } from '@heroicons/react/20/solid'
import { MinusCircleIcon } from '@heroicons/react/24/outline'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

export default function AthleteRosterManagementListItem({ 
    athlete, 
    coaches, 
    groupId,
    actionTag = 'add',
    actionIcon = <MinusCircleIcon className="text-gray-400 h-8" />, 
    OnAthletePressed = () => {},
}) {

    const { ShowModal } = useContext(ModalContext)

    const [hideBackgroundHoverColor, setHideBackgroundHoverColor] = useState(false)

    const GetTrainingPeaksMappingAssignerCoachName = (trainingPeaksMappingAssignerCoachId) => {
        if (trainingPeaksMappingAssignerCoachId === null) return 'TrainingPeaks account connected'

        const coach = coaches.find(coach => coach.id === trainingPeaksMappingAssignerCoachId)
        return coach ? `TrainingPeaks account connected by ${coach.firstName} ${coach.lastName.charAt(0).toUpperCase()}.` : 'TrainingPeaks account connected'
    }

    const AthleteListItemPressed = () => {
        if (
            actionTag === 'add' 
            && athlete.kinesisUserGroupId !== null
            && parseInt(groupId) !== parseInt(athlete.kinesisUserGroupId)
        ) {
            const modalData = {
                key: ModalKey.ActionWarning,
                size: 'quarter',
                titleText: `Switch ${athlete.firstName} to a different group?`,
                bodyText: [
                    `${athlete.firstName} ${athlete.lastName} already belongs to a group.`,
                    'Are you sure you want to remove them from their current group and add them to this one?'
                ],
                buttonText: 'Switch Groups',
                buttonAction: () => OnAthletePressed()
            }

            ShowModal(modalData)

            return
        }
        
        OnAthletePressed()
    }

    return (
        <li 
            className={`
                w-full flex items-center px-6 py-4 gap-x-6 cursor-pointer select-none
                ${hideBackgroundHoverColor ? '' : 'hover:bg-gray-50'} 
            `}
            onClick={AthleteListItemPressed}
        >
            {athlete.firstName.length > 0 && athlete.lastName.length > 0 && (
                <div className="h-12 w-12 bg-orange-400 rounded-full flex items-center">
                    <div className='w-full text-center text-white text-base font-semibold tracking-[-1px] pr-[1px]'>
                        {athlete.firstName.charAt(0).toUpperCase()} {athlete.lastName.charAt(0).toUpperCase()}
                    </div>
                </div>
            )}

            {(athlete.firstName.length === 0 || athlete.lastName.length === 0 )&& (
                <div className="h-12 w-12 bg-orange-400 rounded-full items-center">
                    <UserIcon className="h-8 text-white m-2" />
                </div>
            )}

            <div className="flex-grow">
                <p className="font-lg font-semibold">{athlete.firstName} {athlete.lastName}</p>
                {/* {athlete.kinesisUserGroupId} */}
                
                {athlete.email.length > 0 && <p className="text-sm text-gray-600">{athlete.email}</p>}
                {athlete.email.length === 0 && <p className="text-sm text-gray-600">No Email</p>}
            </div>
            
            {athlete.trainingPeaksUserId.length > 0 &&
                <div 
                    className="relative group"
                    onMouseEnter={() => setHideBackgroundHoverColor(true)}
                    onMouseLeave={() => setHideBackgroundHoverColor(false)}
                    onClick={(e) => { e.stopPropagation(); }} // TODO: Open TrainingPeaks Athlete Calendar in new tab?
                >
                    <img 
                        src={trainingPeaksAppIcon}
                        alt="TrainingPeaks App Icon" 
                        className="h-8 w-8 rounded-md" 
                    />

                    <div className="absolute right-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-10">
                        {GetTrainingPeaksMappingAssignerCoachName(athlete.trainingPeaksMappingAssignerCoachId)}
                    </div>
                </div>
            }

            {(
                actionTag === 'add' 
                && athlete.kinesisUserGroupId !== null
                && parseInt(groupId) !== parseInt(athlete.kinesisUserGroupId)
            ) && (
                <p className='text-sm text-gray-600'>
                    Currently in another group
                </p>
            )}

            {actionIcon}
        </li>
    )
}